import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { TrackingHelper } from 'client/tracking/maps/helper';

const map = {
  vin_call_dealer(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.CALL_DEALER,
      TrackingHelper.getBasicDealerOptions(options)
    );
  },
  vin_show_content: TrackingEvent.actionCompleted(TrackingConstant.ACTION_SHOW_CONTENT, TrackingConstant.FIND_OUT_WHY),
  vin_view_reviews(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.VIEW_DEALER_REVIEWS,
      TrackingHelper.getBasicDealerOptions(options)
    );
  },
  vin_view_dealer_details(options) {
    return TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_DEALER_ENGAGEMENT,
      TrackingConstant.VIEW_DEALER_DETAILS,
      TrackingHelper.getBasicDealerOptions(options)
    );
  },
  vin_view_directions: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.GET_DIRECTIONS_TO_DEALER
  ),
  view_details: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.VIEW_DETAILS),
};

export const InventoryCommonMap = {
  ...map,
};
